import React from "react";

import { useTranslation, Trans } from "react-i18next";

import { Text } from "@ui/elements";

type TotalTextProps = {
  total_tips?: number;
  total_matches?: number;
  isLoading?: boolean;
};

export const TotalText: React.FC<TotalTextProps> = ({
  total_tips = 0,
  total_matches = 0,
  isLoading,
}) => {
  const { t } = useTranslation();

  if (total_tips === 0 && total_matches === 0) {
    return null;
  }

  return (
    <Text
      variant="secondary"
      isLoading={isLoading}
      style={{ width: "fit-content" }}
    >
      <Trans
        i18nKey="total-text"
        values={{
          tips: t("count-tip", { count: total_tips }),
          matches: t("count-match", { count: total_matches }),
        }}
      />
    </Text>
  );
};
